/** Overall exam status values stored in tbl_student_exam.status (API/DB). */
export const EXAM_OVERALL_STATUSES = [
  "Pending",
  "In Progress",
  "Annotated Once",
  "Annotated Twice",
];

/** i18n keys for overall exam status labels (exams.statusOptions.*). */
export const EXAM_STATUS_LABEL_KEYS = {
  Pending: "exams.statusOptions.pending",
  "In Progress": "exams.statusOptions.inProgress",
  "Annotated Once": "exams.statusOptions.annotatedOnce",
  "Annotated Twice": "exams.statusOptions.annotatedTwice",
  Submitted: "exams.statusOptions.submitted",
  Completed: "exams.statusOptions.completed",
};

/** Status filter dropdown: stable API value + i18n label key. */
export const EXAM_STATUS_FILTER_OPTIONS = [
  { value: "", labelKey: null },
  { value: "Pending", labelKey: EXAM_STATUS_LABEL_KEYS.Pending },
  { value: "In Progress", labelKey: EXAM_STATUS_LABEL_KEYS["In Progress"] },
  { value: "Annotated Once", labelKey: EXAM_STATUS_LABEL_KEYS["Annotated Once"] },
  { value: "Annotated Twice", labelKey: EXAM_STATUS_LABEL_KEYS["Annotated Twice"] },
];
